import React, { useState } from "react";
import {
  Box,
  Button,
  TextField,
  Tabs,
  Tab,
  Typography,
  Card,
  CardContent,
  MenuItem,
  IconButton,
} from "@mui/material";

import { useTheme } from "@mui/material";
import { Formik } from "formik";
import * as yup from "yup";
import Header from "../../components/Header";
import { tokens } from "../../theme";
import { useNavigate } from "react-router-dom";
import { iepaProd } from "../../constants/global";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";

const ViewRoutes = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [activeTab, setActiveTab] = useState(0); // To manage active tab
  const navigate = useNavigate(); // For page navigation

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null); //Error
  const [routeId, setRouteId] = useState(null);
  const [selectedRoute, setSelectedRoute] = useState(null);
  const location = useLocation();
  const [isEditing, setIsEditing] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { selectedRows, routes } = location.state || {};

  console.log("selectedRows", selectedRows, routes);

  // When selectedRows change, update the selectedRoute
  useEffect(() => {
    if (!!selectedRows) {
      // Assuming selectedRows contains an array with one object that has an 'id' field
      const selectedId = selectedRows.id;
      const route = routes.find((p) => p.id === selectedId);
      setSelectedRoute(route);
      setRouteId(selectedId);
    } else {
      setSelectedRoute(null); // Reset if no product is selected
    }
  }, [selectedRows, routes]); // Re-run whenever selectedRows or products change

  console.log("selectedRoute", selectedRoute);
  // Handle dynamic initial values based on selectedRoute
  const initialValues = selectedRoute
    ? {
        routeCode: selectedRoute ? selectedRoute.code || "" : "",
        routeName: selectedRoute ? selectedRoute.name || "" : "",
        routeShortName: selectedRoute ? selectedRoute.shortName || "" : "",
        startDate: selectedRoute ? selectedRoute.activeStartDate || "" : "",
        endDate: selectedRoute ? selectedRoute.activeEndDate || "" : "",
      }
    : {
        routeCode: "",
        routeName: "",
        routeShortName: "",
        startDate: "",
        endDate: "",
      };

  const handleClose = () => {
    navigate("/RouteList"); // Redirect to /CustomerList
  };

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  useEffect(() => {
    setLoading(true);
  }, []);
  console.log("initialValues", initialValues);

  const handleFormSubmit = (values, { resetForm }) => {
    const data = {
      id: routeId,
      name: values.routeName,
      shortName: values.routeShortName,
      code: values.routeCode,
      // type: values.temporary,
      activeStartDate: values.startDate,
      activeEndDate: values.endDate,
      orgId: "1",
      updatedBy: 1,
    };

    console.log("Send data");
    console.log(data);

    fetch(`${iepaProd.iepaInventorySrvAPI}/inventory/routes/update`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        setMessage("Route added successfully!");
        setError(null);
        resetForm();
      })
      .catch((error) => {
        setError("Failed to add Route. Please try again.");
        setMessage(null);
      });
  };

  const tabContent = [
    {
      label: "Route Details",
      content: selectedRoute ? (
        <Formik
          initialValues={initialValues}
          validationSchema={routeSchema}
          onSubmit={handleFormSubmit}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            setFieldValue,
            resetForm,
          }) => (
            <form onSubmit={handleSubmit}>
              {console.log("values", values)}
              <Box display="flex" flexDirection="column" gap="20px" mt="20px">
                <TextField
                  fullWidth
                  required
                  id="routeCode"
                  label="Route Code"
                  value={values.routeCode || ""}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.routeCode && Boolean(errors.routeCode)}
                  helperText={touched.routeCode && errors.routeCode}
                  inputProps={{ readOnly: !isEditing }}
                />
                <TextField
                  fullWidth
                  required
                  id="routeName"
                  label="Route Name"
                  value={values.routeName || ""}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.routeName && Boolean(errors.routeName)}
                  helperText={touched.routeName && errors.routeName}
                  inputProps={{ readOnly: !isEditing }}
                />
                <TextField
                  fullWidth
                  id="routeShortName"
                  label="Route Short Name"
                  value={values.routeShortName}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={
                    touched.routeShortName && Boolean(errors.routeShortName)
                  }
                  helperText={touched.routeShortName && errors.routeShortName}
                  inputProps={{ readOnly: !isEditing }}
                />
                <TextField
                  sx={{ flex: 1 }}
                  id="startDate"
                  label="Start Date"
                  type="date"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  value={values.startDate}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.startDate && Boolean(errors.startDate)}
                  helperText={touched.startDate && errors.startDate}
                  margin="normal"
                  inputProps={{ readOnly: !isEditing }}
                />
                <TextField
                  sx={{ flex: 1 }}
                  id="endDate"
                  label="End Date"
                  type="date"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  value={values.endDate}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.endDate && Boolean(errors.endDate)}
                  helperText={touched.endDate && errors.endDate}
                  margin="normal"
                  inputProps={{ readOnly: !isEditing }}
                />
              </Box>
              {isLoading && <p>Processing...</p>}{" "}
              {/* Show "Processing..." while loading */}
              {message && <div className="success-message">{message}</div>}
              {error && <div className="error-message">{error}</div>}{" "}
              {/* Error message */}
              <Box display="flex" gap={2} sx={{ mt: 3 }}>
                <Button
                  type="submit"
                  sx={{
                    backgroundColor: colors.blueAccent[700],
                    color: colors.primary[400],
                    fontSize: "14px",
                    fontWeight: "bold",
                    margin: "10px",
                  }}
                  variant="contained"
                >
                  Save
                </Button>

                <Button
                  // type="submit"
                  sx={{
                    backgroundColor: colors.blueAccent[700],
                    color: colors.primary[400],
                    fontSize: "14px",
                    fontWeight: "bold",
                    margin: "10px",
                  }}
                  variant="contained"
                  onClick={() => {
                    resetForm(); // Reset form when clicked
                  }}
                >
                  Reset
                </Button>
              </Box>
            </form>
          )}
        </Formik>
      ) : (
        <Typography>Loading...</Typography>
      ),
    },
  ];

  return (
    <Box m="20px">
      <Header title="View Routes" subtitle="View/Edit Route Details" />
      <Box display="flex" justifyContent="flex" mb="20px">
        <IconButton
          onClick={handleClose}
          sx={{
            position: "absolute",
            top: 10,
            right: 10,
          }}
        >
          <Typography
            sx={{ fontWeight: "bold", fontSize: "16px", marginRight: "5px" }}
          >
            Close
          </Typography>{" "}
          <CloseIcon />
        </IconButton>
        {/* <Button
          color="secondary"
          variant="contained"
          onClick={() => window.history.back()} // Navigates back in history
          sx={{
            backgroundColor: "black",
            color: colors.primary[400],
            fontSize: "14px",
            fontWeight: "bold",
            margin: "10px",
          }}
        >
          Go Back
        </Button> */}
        <Button
          color="secondary"
          variant="contained"
          onClick={() => setIsEditing(true)}
          sx={{
            backgroundColor: colors.blueAccent[700],
            color: colors.primary[400],
            fontSize: "14px",
            fontWeight: "bold",
            margin: "10px",
          }}
        >
          Edit
        </Button>
      </Box>
      <Card>
        <CardContent>
          <Tabs value={activeTab} onChange={handleTabChange}>
            {tabContent.map((tab, index) => (
              <Tab
                key={index}
                label={tab.label}
                sx={{
                  color: activeTab === index ? "black" : colors.blueAccent[700], // Active tab color
                  fontWeight: activeTab === index ? "bold" : "normal", // Optional: Bold for active tab
                }}
              />
            ))}
          </Tabs>

          <Box mt="20px">{tabContent[activeTab].content}</Box>
        </CardContent>
      </Card>
    </Box>
  );
};

const routeSchema = yup.object().shape({
  routeCode: yup.string().required("Route Code is required"),
  routeName: yup.string().required("Route Name is required"),
  routeShortName: yup.string().required("Route Short Name is required"),
});

export default ViewRoutes;
